module.exports = __webpack_public_path__ + "img/customerLogo3.be2cfab6.png";